import { Routes, RouterModule } from '@angular/router';
import { Learner } from './components/main/learner.component';
import { AuthenticatedRoutesGuard } from '../app/services/authenticated-routes-guard.service';
import { ProductView } from './../../modules/shared/components/product-view/product-view.component';
import { LearnerProductViewResolverService } from './services/learner-product-view.resolver.service';
import { ActivityView } from './../../modules/shared/components/activity-view/activity-view.component';
import { LearnerActivityViewResolverService } from './services/learner-activity-view-resolver.service';
import { ActivityLaunch } from './../../modules/shared/components/activity-launch/activity-launch.component';
import { SaveWarningGuard } from 'modules/shared/services/save-warning-guard.service';
import { CanDeactivateLPGuard } from 'modules/shared/services/can-deactivate-lp-guard.service';
import { CreateUserAnalytics } from './components/create-user-analytics/create-user-analytics.component';

const routes: Routes = [
    {
        path: 'learner', component: Learner, canActivate: [AuthenticatedRoutesGuard], children: [
            { path: ':spaceId/product/:productCode', component: ProductView, resolve: { productViewResolverData: LearnerProductViewResolverService } },
            { path: ':spaceId/product/:productCode/folder/:folderId', component: ProductView, resolve: { productViewResolverData: LearnerProductViewResolverService } },
            {
                path: ':spaceId/product/:productCode/view', component: ActivityView, canDeactivate: [CanDeactivateLPGuard], resolve: { activityViewResolverData: LearnerActivityViewResolverService }, children: [
                    { path: 'item/:itemId', component: ActivityLaunch, canDeactivate: [SaveWarningGuard] }
                ]
            },
            {
                path: ':spaceId/product/:productCode/folder/:folderId/view', component: ActivityView, canDeactivate: [CanDeactivateLPGuard], resolve: { activityViewResolverData: LearnerActivityViewResolverService }, children: [
                    { path: 'item/:itemId', component: ActivityLaunch, canDeactivate: [SaveWarningGuard] }
                ]
            },
            { path: ':spaceId/class/:classId/product/:productCode', component: ProductView, resolve: { productViewResolverData: LearnerProductViewResolverService } },
            {
                path: ':spaceId/class/:classId/product/:productCode/view', component: ActivityView, canDeactivate: [CanDeactivateLPGuard], resolve: { activityViewResolverData: LearnerActivityViewResolverService }, children: [
                    { path: 'item/:itemId', component: ActivityLaunch, canDeactivate: [SaveWarningGuard] }
                ]
            },
            {
                path: ':spaceId/class/:classId/product/:productCode/assignment/:assignmentId/view', component: ActivityView, canDeactivate: [CanDeactivateLPGuard], resolve: { activityViewResolverData: LearnerActivityViewResolverService }, children: [
                    { path: 'item/:itemId', component: ActivityLaunch, canDeactivate: [SaveWarningGuard] }
                ]
            },
            {
                path: ':spaceid/createUA/product/:productcode/class/:classid', component: CreateUserAnalytics
            },
        ]
    }
];

export const ROUTES = RouterModule.forChild(routes);
